import { BrandKitColors } from '@wrkbelt/shared/types-data';
import { SCHEDULER_COMMON_PREFIX } from '@wrkbelt/shared/utils-booking-flow-data-logic';
import {
  SCHEDULER_EVENT_PREFIX,
  SCHEDULER_PORTAL_ID,
  SchedulerListenerEvents,
} from '@wrkbelt/ui-components';

/**
 * CDN-specific events for the bundle lifecycle
 * These events are only relevant to the CDN bundle loading process
 * and operate alongside the core scheduler events
 */
export enum SchedulerCdnBundleEvents {
  /** Fired when the CDN bundle begins loading */
  BUNDLE_LOADING = `${SCHEDULER_EVENT_PREFIX}bundle_loading`,
  /** Fired when the CDN bundle has loaded successfully */
  BUNDLE_LOADED = `${SCHEDULER_EVENT_PREFIX}bundle_loaded`,
  /** Fired when there's an error loading the CDN bundle */
  BUNDLE_ERROR = `${SCHEDULER_EVENT_PREFIX}bundle_error`,
}

// Re-export core scheduler events for convenience
export { SchedulerListenerEvents };

/**
 * All scheduler events that can be listened to by client websites
 * Combines core scheduler events and CDN-specific events
 */
export type SchedulerEvents =
  | SchedulerListenerEvents
  | SchedulerCdnBundleEvents;

/**
 * Data attributes that can be set on the scheduler script tag
 * These attributes provide configuration options for the scheduler
 */
export enum SchedulerCdnDataAttributes {
  ORGANIZATION_ID = 'data-organization-id',
  DEFAULT_BRAND_KIT = 'data-default-brand-kit',
  SCHEDULER_CONFIG = 'data-scheduler-config',
}

/**
 * DOM element selectors used by the scheduler
 * These IDs are used to mount the scheduler and its container
 * Uses the common prefix from the scheduler component for consistency
 */
export enum SchedulerCdnSelectors {
  ROOT = `${SCHEDULER_COMMON_PREFIX}-root`,
  PORTAL = SCHEDULER_PORTAL_ID,
}

/**
 * Asset paths for scheduler resources
 * These paths are used to load scheduler assets from the CDN
 */
export enum SchedulerCdnAssetPaths {
  VERSION_MANIFEST = '/version-manifest.json',
}

/**
 * Default brand colors to use if none are provided
 * Follows Wrkbelt's brand guidelines
 */
export const DEFAULT_BRAND_COLORS: BrandKitColors = {
  primary: '#000000',
  secondary: '#acacac',
  accent: '#dddddd',
};
